<!--
 * @Description: 泵机调度
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: 刘小二
 * @LastEditTime: 2022-08-15 15:22:24
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="margin-bottom: 10px; display: inline-block">
                <span style="margin-right: 12px">泵送队</span>
                <el-input v-model="tableParam.pumpingTeam" style="width: 200px; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px; margin-bottom: 10px; display: inline-block">
                <span style="margin-right: 12px">工程名称</span>
                <el-input v-model="tableParam.engineeringName" style="width: 200px%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px; margin-bottom: 10px; display: inline-block">
                <span style="margin-right: 12px">站点名称</span>
                <el-input v-model="tableParam.station" style="width: 200px%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px; margin-bottom: 10px; display: inline-block">
                <span style="margin-right: 12px">泵自编号</span>
                <el-input v-model="tableParam.pumpNo" style="width: 200px; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px; margin-bottom: 10px; display: inline-block">
                <span style="margin-right: 12px">泵类型</span>
                <el-select v-model="tableParam.pumpTypeId" style="width: 200px; max-width: 150px" placeholder="请选择">
                  <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">浇筑时间</span>
                <el-date-picker
                  v-model="startTimDateEndTimDate"
                  type="datetimerange"
                  unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  @change="(tableParam.pouringTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endPouringTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"
                ></el-date-picker>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '图算添加人'">{{ scope.row.registeredAddress | stationsFun }}</span>
                    <div v-else-if="item.prop == 'sureStatus'">
                      <el-link class="table_link" :underline="false">{{ ["待确认", "已确认", "已完工"][scope.row.sureStatus * 1] }}</el-link>
                    </div>
                    <div v-else-if="item.prop == 'type'">
                      <!-- :disabled="scope.row.type * 1 == 0 && scope.row.sureStatus * 1 != 1 ? true : false" -->
                      <el-link
                        :class="{ table_link: !(scope.row.pumpOnDutyQuantityStatus && scope.row.type * 1 == 0) }"
                        :type="scope.row.pumpOnDutyQuantityStatus && scope.row.type * 1 == 0 ? 'warning' : 'default'"
                        :underline="false"
                        @click="handleClick(scope.row)"
                        >{{ ["未提交", "待查看", "确认完工", "已拒绝"][scope.row.type * 1] }}</el-link
                      >
                    </div>
                    <div v-else-if="item.label == '调度'">
                      <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'DIAODU') !== -1" class="table_link" :underline="false" @click="ToViewFun(scope.row)">调度</el-link>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 调度 -->
    <el-dialog v-dialogDrag :visible.sync="ToViewType" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">泵车调度</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formData" label-width="110px">
          <el-form-item label="泵自编码">
            <el-input v-model="formData.pumpNo" clearable disabled></el-input>
          </el-form-item>
          <el-form-item label="泵类型">
            <el-input v-model="formData.pumpTypeName" disabled clearable></el-input>
          </el-form-item>
          <el-form-item prop="dispatchTypeId" label="调度类型">
            <el-select v-model="formData.dispatchTypeId" placeholder="请选择">
              <el-option v-for="item in dispatchTypeList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="carFrom" label="车辆来源">
            <el-select v-model="formData.carFrom" placeholder="请选择">
              <el-option label="罐车" :value="1"></el-option>
              <el-option label="东风车" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="formData.carFrom === 2" label="东风车">
            <el-input v-model="formData.carTypeName" disabled clearable></el-input>
          </el-form-item>
          <el-form-item v-show="formData.carFrom === 2" label="司机">
            <el-input v-model="formData.driverName" disabled clearable></el-input>
          </el-form-item>
          <el-form-item label="调度描述">
            <el-input v-model="formData.remark" :rows="5" resize="none" style="width: 760px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="ToViewType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit()">通知司机</el-button>
      </span>
    </el-dialog>
    <!-- 完工申请 -->
    <el-dialog v-dialogDrag :visible.sync="finishApplyDig" width="1160px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ finishApplyTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="finishApplyForm" :inline="true" :model="finishApplyForm" label-width="110px">
          <el-form-item label="泵送量:">
            <span>{{ finishApplyForm.countNum }}</span>
          </el-form-item>
          <el-form-item
            prop="confirmationAmount"
            label="确认总量:"
          >
          <span>{{ finishApplyForm.confirmationAmount }}</span>
            <!-- <el-input-number v-model="finishApplyForm.confirmationAmount" :controls="false" :disabled="finishApplyForm.type != 1 && finishApplyForm.type != 0" clearable></el-input-number> -->
          </el-form-item>
          <el-button class="bottom_all_two" style="margin-left: 24px" @click="addItem()">添加</el-button>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-bottom: 10px" :data="workNumData" tooltip-effect="dark">
            <el-table-column label="泵工" align="center" width="200" prop="userName">
              <template slot-scope="scope">
                <el-input v-if="pupDataType == 2" v-model="scope.row.userName" :disabled="scope.row.id?true:false" placeholder="请输入" style="width: 100%"></el-input>
                <el-select v-if="pupDataType == 1" v-model="scope.row.userName" :disabled="scope.row.id?true:false" style="width: 100%" placeholder="请选择">
                  <el-option v-for="item in pupManList" :key="item.pumpManName" :label="item.pumpManName" :value="item.pumpManName" @click.native="scope.row.userId = item.pumpManId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="当班量" align="center" width="auto" prop="volume">
              <template slot-scope="scope">
                <el-input v-model="scope.row.volume" :disabled="scope.row.id?true:false" placeholder="请输入" style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="开始时间" align="center" width="200" prop="startTime">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.startTime" :disabled="scope.row.id?true:false" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间"> </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="结束时间" align="center" width="200" prop="endTime">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.endTime" :disabled="scope.row.id?true:false" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间"> </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="站点" align="center" width="150" prop="stationName">
              <template slot-scope="scope">
               <el-select v-model="scope.row.stationId" :disabled="scope.row.id?true:false" placeholder="请选择" style="width:100%">
                    <el-option v-for="(item, index) in stationList" :key="index" :label="item.stationName" :value="item.stationId" @click.native="scope.row.stationName = item.stationName"></el-option>
                  </el-select>
              </template>
            </el-table-column>
            <el-table-column label="确认量" width="auto" align="center" prop="sureVolume">
              <template slot-scope="scope">
                <el-input v-if="scope.row.id?false:true" v-model="scope.row.sureVolume" placeholder="请输入" style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                <el-input v-else v-model="scope.row.sureVolume" :disabled="finishApplyForm.type !== 0 && finishApplyForm.type !== 1" placeholder="请输入" style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" @blur="saveSureVolume(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="finishApplyForm.type == 0 || finishApplyForm.type == 1" label="操作" align="center" width="150">
              <template slot-scope="scope">
              <el-button v-if="scope.row.id?false:true" size="mini" class="bottom_one" @click="saveWorkNum(scope.row)"> 保存 </el-button>
              <el-button size="mini" class="bottom_two" @click="deleteWorkNum(scope.row, scope.$index)"> 删除 </el-button>
            </template>
            </el-table-column>
          </el-table>
          <el-form-item label="完工情况:">
            <span>{{ finishApplyForm.reasonApplication }}</span>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="finishApplyForm.auditRemark" type="textarea" :disabled="finishApplyForm.type != 1 && finishApplyForm.type != 0" :rows="2" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_tree" @click="finishApplyDig = false">关 闭</el-button>
        <el-button v-if="finishApplyForm.type == 1" class="bottom_all_two" @click="refuseFinishApply()">拒 绝</el-button>
        <el-button v-if="finishApplyForm.type == 1" class="bottom_all" style="margin-left: 24px" @click="saveFinishApply()">同 意</el-button>
        <el-button v-if="finishApplyForm.type == 0 &&  finishApplyForm.sureStatus * 1 != 0" class="bottom_all" style="margin-left: 24px" @click="saveFinishApply()">确认完工</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getDicType } from "@/api/common.js";
import { queryPage, save_inform_driver, queryDispatchInfor, updateAssian, getAssian, get_pump_handover_amount, updateAssianWait,saveOrupdateQuantityResord,appQuerySatation } from "@/api/smart/schedul/i.js";
import { getUserId } from "@/utils/auth";
export default {
  mixins: [mixin],
  data() {
    return {
      startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      loading: false,
      /*表格数据*/
      table: [
        {
          label: "泵自编号",
          width: "",
          prop: "pumpNo",
          status: true,
        },
        {
          label: "车牌号",
          width: "",
          prop: "plateNumber",
          status: true,
        },
        {
          label: "泵类型",
          width: "",
          prop: "pumpTypeName",
          status: true,
        },
        {
          label: "泵工",
          width: "",
          prop: "pumpPersons",
          status: true,
        },
        {
          label: "订单编号",
          width: "",
          prop: "orderNo",
          status: true,
        },
        {
          label: "浇筑部位",
          width: "",
          prop: "structuralParts",
          status: true,
        },
        {
          label: "产品名称",
          width: "",
          prop: "productName",
          status: true,
        },
        {
          label: "浇筑时间",
          width: "",
          prop: "pouringTime",
          status: true,
        },
        {
          label: "所在工程",
          width: "",
          prop: "engineeringName",
          status: true,
        },
        {
          label: "站点名称",
          width: "",
          prop: "station",
          status: true,
        },
        {
          label: "泵送队",
          width: "",
          prop: "pumpingTeam",
          status: true,
        },
        {
          label: "泵机状态",
          width: "",
          prop: "sureStatus",
          status: true,
        },
        {
          label: "完工申请",
          width: "",
          prop: "type",
          status: true,
        },
        {
          label: "调度",
          width: "",
          prop: "",
          status: true,
        },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        dispatchTypeId: [{ required: true, message: "请选择调度类型", trigger: "blur" }],
        carFrom: [{ required: true, message: "请选择车辆来源", trigger: "blur" }],
      },
      formData: {},
      pumpTypeArr: [],
      dispatchTypeList: [],
      id: "",
      ToViewType: false,
      /*完工申请开始 */
      finishApplyDig: false,
      finishApplyTitle: "完工申请",
      finishApplyForm: {
        confirmationAmount: null,
        auditRemark: "",
        countNum: "",
      },
      workNumData: [],
      pupDataType: 1,
      pupManList: [],
      stationList:[],
      /*完工申请结束 */
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.pouringTime = val[0];
        this.tableParam.endPouringTime = val[1];
      } else {
        this.tableParam.pouringTime = "";
        this.tableParam.endPouringTime = "";
      }
    },
  },
 async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, name: "", linkman: "", pouringTime: "", endPouringTime: "" };
    this.tableParam.pumpingTeamId = getUserId();
    this.tableParam.pouringTime = this.startTimDateEndTimDate[0] || "";
    this.tableParam.endPouringTime = this.startTimDateEndTimDate[1] || "";
    this.gettableData();
    getDicType({ code: "castingType" }).then(res => {
      this.pumpTypeArr = res.data.items; //
    });
    getDicType({ code: "dispatchType" }).then(res => {
      this.dispatchTypeList = res.data.items; //
    });
  },
  methods: {
    //保存完工申请 明细表 开始
    //保存确认量
    saveSureVolume(row){
      saveOrupdateQuantityResord({id:row.id,sureVolume:row.sureVolume}).then(res => {
        if(res.code == 1001) {
          this.getPumpAmount()
          this.$message.success('修改成功!')
        }
      })
    },
    //保存
    saveWorkNum(row) {
      if(!row.userName||!row.volume||!row.startTime || !row.endTime || !row.stationName || !row.sureVolume){
        this.$message.warning('请检查当前行是否填写完整!')
        return
      }
      saveOrupdateQuantityResord(row).then(res => {
        if(res.code == 1001) {
          this.getPumpAmount()
          this.$message.success('保存成功!')
        }
      })
    },
    //添加
    addItem() {
      let data = {
        assignId:this.finishApplyForm.pumpingid,
        volume:"",
        startTime:"",
        endTime:"",
        userName:"",
        userId:"",
        stationName:"",
        stationId:"",
        sureVolume:"",
        id:"",
      }
      this.workNumData.push(data)
    },
    //删除
    deleteWorkNum(row,index){
      if(!row.id){
        this.workNumData.splice(index,1)
      } else {
        saveOrupdateQuantityResord({id:row.id,status:0}).then(res => {
        if(res.code == 1001) {
          this.getPumpAmount()
          this.$message.success('删除成功!')
        }
      })
      }
    },
    //保存完工申请 明细表 结束
    submit() {
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          const params = {
            planId: this.formData.planId,
            dispatchType: this.dispatchTypeList.find(item => item.id === this.formData.dispatchTypeId).itemName,
            dispatchTypeId: this.formData.dispatchTypeId,
            pumpNo: this.formData.pumpNo,
            plateNumber: this.formData.plateNumber,
            driverId: this.formData.driverId,
            driverName: this.formData.driverName,
            engineeringName: this.formData.engineeringName,
            address: this.formData.address,
            structuralParts: this.formData.structuralParts,
            pumpType: this.formData.pumpType,
            pumpTypeId: this.formData.pumpTypeId,
            carFrom: this.formData.carFrom,
            station: this.formData.station,
            stationId: this.formData.stationId,
            company: this.formData.company,
            companyId: this.formData.companyId,
            pumpingId: this.formData.pumpingid,
            remark: this.formData.remark,
          };
          save_inform_driver(params).then(res => {
            if (res.code == 1001) {
              this.ToViewType = false;
              this.$message({
                message: "调度成功",
                type: "success",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClick(data) {
      // if (data.type === 0) return;
      this.finishApplyForm = JSON.parse(JSON.stringify(data));
      if (data.type == 1) {
        this.finishApplyForm.confirmationAmount = data.pumpingVolume;
      } else {
        getAssian({ id: data.pumpingid }).then(res => {
          if (res.code == 1001) {
            this.finishApplyForm.confirmationAmount = res.data.confirmationAmount;
            this.$set(this.finishApplyForm, "auditRemark", res.data.auditRemark);
          }
        });
      }
      this.getPumpAmount()
      appQuerySatation({planId:data.planId}).then(res => {
        if(res.code == 1001) {
          this.stationList = res.data
        }
      })
      this.finishApplyDig = true;
      // this.$confirm(`${data.reasonApplication}`, "完工申请", {
      //   confirmButtonText: "同意",
      //   cancelButtonText: data.type === 1 ? "拒绝" : "关闭",
      //   cancelButtonClass: "bottom_all_two",
      //   confirmButtonClass: "bottom_all",
      //   distinguishCancelAndClose: true,
      //   type: "info",
      //   showConfirmButton: data.type === 1,
      // })
      //   .then(() => {

      //   })
      //   .catch(action => {
      //     if (data.type !== 1) return;
      //     if (action === "close") return;

      //   });
    },
    //完工申请明细列表
    getPumpAmount(){
      get_pump_handover_amount({ assignId: this.finishApplyForm.pumpingid }).then(res => {
        if (res.code == 1001) {
          this.workNumData = res.data?.data ? res.data.data : [];
          this.pupDataType = res.data.dataType;
          this.pupManList = res.data.pumpMans;
          this.finishApplyForm.countNum = res.data.count || "";
          this.finishApplyForm.confirmationAmount = this.workNumData.reduce((prev,cur) => {
            prev = prev + cur.sureVolume
            return prev
          },0)
        }
      });
    },
    //同意完工申请
    saveFinishApply() {
      const params = {
        planId: this.finishApplyForm.planId,
        reasonStatus: 2,
        id: this.finishApplyForm.pumpingid,
        pumpingTeamId: this.finishApplyForm.pumpingTeamId,
        confirmationAmount: this.finishApplyForm.confirmationAmount,
        auditRemark: this.finishApplyForm.auditRemark,
      };
      if (this.finishApplyForm.confirmationAmount !== this.finishApplyForm.countNum && !this.finishApplyForm.auditRemark) {
        this.$message.warning("确认总量泵送量不相等，请填写备注！");
        return;
      }
      if (this.finishApplyForm.type * 1 == 0) {
        updateAssianWait(params).then(res => {
          if (res.code === 1001) {
            this.$message.success("操作成功");
            this.finishApplyDig = false;
            this.gettableData();
          }
        });
      } else {
        updateAssian(params).then(res => {
          if (res.code === 1001) {
            this.$message.success("操作成功");
            this.finishApplyDig = false;
            this.gettableData();
          }
        });
      }
    },
    //拒绝完工申请
    refuseFinishApply() {
      const params = {
        planId: this.finishApplyForm.planId,
        reasonStatus: 3,
        id: this.finishApplyForm.pumpingid,
        pumpingTeamId: this.finishApplyForm.pumpingTeamId,
        confirmationAmount: this.finishApplyForm.confirmationAmount,
      };
      updateAssian(params).then(res => {
        if (res.code === 1001) {
          this.$message.success("操作成功");
          this.finishApplyDig = false;
          this.gettableData();
        }
      });
    },
    ToViewFun(e) {
      this.id = e.id;
      this.formData = e;
      queryDispatchInfor({ pumpingId: e.pumpingid }).then(res => {
        if (res.code === 1001) {
          if (res.data) {
            this.formData.id = res.data.id;
            this.formData.dispatchTypeId = res.data.dispatchTypeId;
            this.formData.carFrom = res.data.carFrom * 1;
            this.formData.remark = res.data.remark;
          }
          this.ToViewType = true;
        }
      });
    },
    init() {
      /*重置数据*/
      this.startTimDateEndTimDate = [];
      this.tableParam.endPouringTime = "";
      this.tableParam.pouringTim = "";
      this.tableParam.pumpingTeam = "";
      this.tableParam.engineeringName = "";
      this.tableParam.pumpNo = "";
      this.tableParam.pumpTypeId = "";
      this.tableParam.station = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_top {
  color: #008000;
}
.table_top:hover {
  color: #008000 !important;
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 320px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
</style>
